import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {
  formatTimeAgo
} from "../../../global/utility/formatTimeAgo";
import dayjs from "dayjs";
import { Spin } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { dateFormatWithAt } from "../../../global/utility/dateFormat";
import getSingleDeviceProfile from "../../DeviceProfile/utility/getSingleDeviceProfile";
import {
  fetchDeviceTypeRequest,
  updateUI,
} from "../../../store/actions/deviceProfile";

const ShipmentFields = ({ shipmentData }) => {
  const dispatch = useDispatch();

  const completionProfile = useSelector((state) =>
    shipmentData?.oncompletion
      ? state.shipment.data.shipProfile?.filter(
          (deviceProfile) =>
            deviceProfile?.profileid === shipmentData?.oncompletion
        )
      : []
  );
  const shipmetProfile = useSelector(
    (state) => state?.shipment?.data?.shipProfile
  );
  const isProfilesRefreshing = useSelector(
    (state) => state?.deviceProfile?.isLoading?.devices
  );
  const fieldsUpdated = useSelector((state) => state.deviceProfile.ui.form.fieldsUpdated);
  const loadingSave = useSelector((state) => state.deviceProfile.isLoading.isCreated);
   const deviceTypes = useSelector(
    (state) => state.deviceProfile.ui.form.deviceTypes
  );
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);

  function getShipmentByid(profileid, key) {
    const item = shipmetProfile?.find((obj) => obj.profileid === profileid);
    return item ? item[key] : null;
  }
  function getValueByDeviceAndKey(diviceid, key) {
    const item = deviceName?.devices?.find((obj) => obj?.uid === diviceid);
    return item ? item[key] : null;
  }

  const handleViewProfile = (id) => {
    if (!fieldsUpdated) return; // guard click until fresh data available
   const singleDeviceProfile = getSingleDeviceProfile(shipmetProfile, id,deviceTypes);
    if (singleDeviceProfile === null) return;
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: true,
          type: "view",
          step: -1,
          ...singleDeviceProfile,
        },
      })
    );
  };

  return (
    <Spin spinning={!fieldsUpdated || loadingSave || isProfilesRefreshing}>
    <Grid2 container spacing={2} style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: 0,
          bottom: 0,
          width: "1px",
          backgroundColor: "#E5E7EB",
          transform: "translateX(-50%)",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "75%",
          top: 0,
          bottom: 0,
          width: "1px",
          backgroundColor: "#E5E7EB",
          transform: "translateX(-50%)",
        }}
      ></div>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Shipment State
          </label>
          <div
            className="input-container text-lg"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {shipmentData?.shipmentstate || "-"}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Completion Date
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {shipmentData?.shipmentstate === "Completed"
              ? dateFormatWithAt(shipmentData?.updatedat)
              : "N/A" || "-"}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Device Profile
          </label>
          <div
            className="input-container underline"
            style={{
              fontSize: "16px",
              fontWeight: "400",
            }}
          >
            {shipmentData?.deviceprofile?.name ||
            shipmentData?.deviceprofile?.profilename ? (
              getShipmentByid(
                shipmentData?.deviceprofile?.id,
                Object.hasOwn(shipmentData?.deviceprofile, "profilename")
                  ? "profilename"
                  : "name"
              ) ? (
                <button
                  className="ats-btn-link"
                  style={{ color: "black" }}
                  disabled={!fieldsUpdated}
                  onClick={() => {
                    if (
                      getShipmentByid(
                        shipmentData?.deviceprofile?.id,
                        Object.hasOwn(
                          shipmentData?.deviceprofile,
                          "profilename"
                        )
                          ? "profilename"
                          : "name"
                      )
                    ) {
                      handleViewProfile(shipmentData?.deviceprofile?.id);
                      return;
                    }
                  }}
                >
                  {getShipmentByid(
                  shipmentData?.deviceprofile?.id,
                  Object.hasOwn(shipmentData?.deviceprofile, "name") ? "name" : "profilename"
                ) || shipmentData?.deviceprofile?.name || shipmentData?.deviceprofile?.profilename}
                </button>
              ) : (
                shipmentData?.deviceprofile?.profilename ||
                shipmentData?.deviceprofile?.name
              )
            ) : (
              "N/A"
            )}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Device ID
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {shipmentData?.deviceid || "-"}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Updated
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {formatTimeAgo(shipmentData?.updatedat)}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Origin
          </label>
          <div
            className="input-container"
            style={{
              fontSize: "16px",
              fontWeight: "400",
              textWrapStyle: "balance",
            }}
          >
            {getShipmentByid(shipmentData?.deviceprofile?.id, "locations")?.[0]?.address || shipmentData?.originLocation?.address ||
              shipmentData?.origin ||
              "-"}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Profile Upon Completion
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {Array.isArray(completionProfile) &&
            completionProfile.length > 0 ? (
              <button
                className="ats-btn-link"
                style={{ color: "black" }}
                onClick={() => {
                  if (shipmentData?.oncompletion) {
                    handleViewProfile(shipmentData?.oncompletion);
                  }
                }}
              >
                {completionProfile[0]?.profilename}
              </button>
            ) : shipmentData?.oncompletion ===
              shipmentData?.deviceprofile?.id ? (
              shipmentData?.deviceprofile?.profilename ||
              shipmentData?.deviceprofile?.name
            ) : (
              "N/A"
            )}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Device Name
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            <div>{getValueByDeviceAndKey(shipmentData?.deviceid, "name") 
              ?? shipmentData?.devicename 
              ?? "N/A"}</div>
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Start Date
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {shipmentData?.startdate
              ? dayjs(shipmentData?.startdate)
                  .format("MM-DD-YY [at] HH:mm:ss")
                  .toLowerCase()
              : null}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Destination
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {/* {shipmentData?.destination ||
              shipmentData?.deviceprofile?.locations?.find(
                (loc) => loc.locationtype === "Destination"
              )?.name ||
              "N/A"} */}
            {getShipmentByid(shipmentData?.deviceprofile?.id, "locations")?.[1]?.address||shipmentData?.destinationLocation?.address ||
              shipmentData?.destination ||
              "-"}
          </div>
        </div>
      </Grid2>
      <Grid2 item xs={12} sm={6} md={3}>
        {/* Empty Grid item to maintain spacing */}
      </Grid2>

      <Grid2 item xs={12} sm={6} md={3}>
        <div className="mb-3">
          <label
            className="input-label-user text-gray-600"
            style={{
              color: "#6F7171",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Device Model
          </label>
          <div
            className="input-container"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {shipmentData?.devicetype || "-"}
          </div>
        </div>
      </Grid2>
    </Grid2>
    </Spin>
  );
};

export default ShipmentFields;
